import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  success: false,
  loading: false,
  loaded: false,
  items: [],
  error: {},
  startAt: null,
  endAt: null,
})

const { Types, Creators } = createActions({
  fetchItems: ['orderKeys'],
  fetchItemsSuccess: ['items'],
  fetchItemsError: ['error'],
})

export const fetchItemsRequestReducer = state => state.set('loading', true)

export const fetchItemsSuccessReducer = (state, { items }) => {
  return state
    .set('loading', false)
    .set('loaded', true)
    .set('success', true)
    .set('items', items)
}

export const fetchItemsErrorReducer = (state, { error }) =>
  state
    .set('error', error)
    .set('success', false)
    .set('loading', false)

export const hasuraItemReducer = createReducer(INITIAL_STATE, {
  [Types.FETCH_ITEMS]: fetchItemsRequestReducer,
  [Types.FETCH_ITEMS_SUCCESS]: fetchItemsSuccessReducer,
  [Types.FETCH_ITEMS_ERROR]: fetchItemsErrorReducer,
})

export const HasuraItemTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/hasuraItemReducer.js